import { Component, Injectable, Input, OnInit } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Component({
  selector: 'app-tool-status',
  templateUrl: './tool-status.component.html',
  styleUrls: ['./tool-status.component.scss'],
})
export class ToolStatusComponent implements OnInit {
  @Input() data: string;

  constructor() {}

  statusName: string;
  statusClassName: string;

  ngOnInit(): void {
    this.assignStatusDetails();
  }

  assignStatusDetails(): void {
    this.statusName = this.data || 'Available';
    this.statusClassName = `status-${this.statusName.toLowerCase().replace(/ /g, '-')}`;
  }
}
